var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "40px",
    height: "40px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4E3C3"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED8B2"
    },
    d: "M501.019,330.352L284.444,113.778l-69.453,129.658L113.778,142.222L89.931,284.157l-4.598,28.732 l197.692,197.692C386.544,499.719,471.678,427.165,501.019,330.352z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 142.222,
    style: {
      fill: "#F4A200"
    },
    width: 28.444,
    height: 170.667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.222,
    y: 199.111,
    style: {
      fill: "#FC6F58"
    },
    width: 28.444,
    height: 113.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 113.778,
    style: {
      fill: "#F9B54C"
    },
    width: 28.444,
    height: 199.111
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6F58"
    },
    d: "M397.902,399.769L397.902,399.769c-9.525,9.525-24.969,9.525-34.494,0l-86.233-86.233l34.494-34.494 l86.233,86.233C407.426,374.801,407.426,390.244,397.902,399.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M277.175,313.535l86.233,86.233c9.525,9.525,24.969,9.525,34.494,0 c0.121-0.121,0.222-0.253,0.341-0.378L294.781,295.929L277.175,313.535z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 236.416,
    cy: 238.278,
    r: 97.556
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M167.791,168.939c-0.121,0.119-0.248,0.229-0.369,0.35c-38.1,38.1-38.1,99.874,0,137.974 s99.874,38.1,137.975,0c0.121-0.121,0.231-0.248,0.35-0.369L167.791,168.939z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B5F1F4"
    },
    cx: 236.416,
    cy: 238.278,
    r: 73.18
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DBFF"
    },
    d: "M185.037,186.185c-0.121,0.119-0.248,0.229-0.369,0.35c-28.575,28.575-28.575,74.905,0,103.481 c28.575,28.575,74.905,28.575,103.481,0c0.121-0.121,0.231-0.247,0.35-0.369L185.037,186.185z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.627,
    y: 303.513,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 829.4546 346.2348)",
    style: {
      fill: "#FD8469"
    },
    width: 48.786,
    height: 82.781
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.13,
    y: 311.945,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 821.0088 366.598)",
    style: {
      fill: "#FC6F58"
    },
    width: 24.898,
    height: 82.781
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6F58"
    },
    d: "M227.556,310.893V199.111h-28.444v102.135C207.95,306.488,217.653,309.693,227.556,310.893z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M199.111,301.246c8.837,5.242,18.542,8.447,28.444,9.647v-82.187l-28.444-28.444V301.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M256,308.769c10.245-2.838,19.987-7.944,28.444-15.32V183.105 c-8.457-7.377-18.199-12.485-28.444-15.32V308.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59E41"
    },
    d: "M256,308.769c10.245-2.838,19.987-7.944,28.444-15.32v-7.854L256,257.15V308.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M170.667,206.153c-9.88,20.218-9.88,44.03,0,64.248V206.153z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGa);
export default __webpack_public_path__ + "static/media/ga.d2b083065426a32d542cd112d8053af9.svg";
export { ForwardRef as ReactComponent };